import React from 'react';
import {updateOverviewSectionContents, closeOverviewSectionPopup} from '../../actions';
import {connect} from 'react-redux';
import OverviewSectionEditPopup from './overview_popup_edit';
import {
    updateIncludedSelectedFeatures,
    updateNotIncludedSelectedFeatures,
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup
} from '../../sections/actions';
import {fetchOverviewFeatures} from '../../../overview/thunks';

class OverviewPopup extends React.Component {

    componentWillUpdate(nextProps) {
        if (nextProps.overviewSectionEditOpen === true && this.props.overviewSectionEditOpen === false) {
            this.props.fetchOverviewFeatures();
        }
    }

    render() {
        return (
            <OverviewSectionEditPopup
                open={this.props.overviewSectionEditOpen}
                title={this.props.overviewSectionTitle}
                body={this.props.overviewSectionBody}
                allFeatures={this.props.allFeatures}
                onUpdateTitleField={
                    title => this.props.updateOverviewSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateOverviewSectionBodyField(body)
                }
                onHandleSubmit={() => {
                    this.props.updateOverviewSectionContents(
                        this.props.pageId,
                        this.props.overviewSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings,
                        this.props.includedFeatures,
                        this.props.notIncludedFeatures
                    )
                }}
                onHandleClose={() => {
                    this.props.closeOverviewSectionPopup();
                }}
                setNotIncludedFeatures={this.props.updateNotIncludedSelectedFeatures}
                setIncludedFeatures={this.props.updateIncludedSelectedFeatures}
                selectedNotIncludedFeatures={this.props.notIncludedFeatures}
                selectedIncludedFeatures={this.props.includedFeatures}
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    overviewSectionEditOpen: state.pageBuilder.overviewSectionPopup.open,
    overviewSectionId: state.pageBuilderSectionPopup.sectionId,
    overviewSectionTitle: state.pageBuilderSectionPopup.data.title,
    overviewSectionBody: state.pageBuilderSectionPopup.data.body,
    allFeatures: state.overview.allOverviewFeatures,
    includedFeatures: state.pageBuilderSectionPopup.includedFeatures,
    notIncludedFeatures: state.pageBuilderSectionPopup.notIncludedFeatures,
});

export default connect(
    mapStateToProps, {
        updateOverviewSectionContents: updateOverviewSectionContents,
        closeOverviewSectionPopup: closeOverviewSectionPopup,
        updateOverviewSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateOverviewSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        fetchOverviewFeatures: fetchOverviewFeatures,
        updateIncludedSelectedFeatures: updateIncludedSelectedFeatures,
        updateNotIncludedSelectedFeatures: updateNotIncludedSelectedFeatures,
    }
)(OverviewPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/overview_popup.js